import { apiBaseURL } from "../ProjectConstants";

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    supplierId: int
*/
async function handleDelSupplierList(supplierId, fetch) {
  const response = await fetch.delete(
    `${apiBaseURL}/api/DeliveryLocation?id=${supplierId}`
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handleDelSupplierList supplierId", supplierId);
  console.log("handleDelSupplierList response", response);

  return {
    response,
    isDataGood,
  };
}
export default handleDelSupplierList;
